import zonas from '../data/zonas';
export const TIPOS_OBJETO = ['mesa', 'silla', 'lounge', 'palco', 'sector', 'pared', 'puerta', 'ventana', 'columna', 'escalera', 'barra', 'escenario', 'plataforma', 'banos', 'entrada', 'texto'];
export const TIPOS_ZONA = ['MESA', 'LOUNGE', 'PALCO', 'SUPER_VIP', 'SECTOR', 'ASIENTO'];
export const DETALLES_ARQUITECTONICOS=['suelo-madera','suelo-hormigon','jardin-vertical','pantalla-led','muro-acustico','sofa-lineal','mesa-blanca'];
export const CAPAS = ['Estructura', 'Mobiliario', 'Zonas', 'Referencias'];
export const nuevaEscena = () => ({
  schemaVersion: 1,
  units: 'm',
  floors: [{
    id: '1P',
    name: 'Planta baja',
    elevation: 0,
    width: 36,
    depth: 56
  }],
  objects: [],
  templates: []
});
const idValido = s => typeof s === 'string' && /^[A-Za-z0-9_-]{1,100}$/.test(s);
export function validarEscena(scene, publicar = false) {
  const errors = [],
    warnings = [];
  if (!scene || scene.schemaVersion !== 1 || scene.units !== 'm' || !Array.isArray(scene.floors) || !Array.isArray(scene.objects)) return {
    errors: ['Formato de plano no compatible.'],
    warnings
  };
  if (JSON.stringify(scene).length > 650000) return {
    errors: ['El plano supera el tamaño máximo de 650 KB.'],
    warnings
  };
  if (scene.floors.some(f => !f || typeof f !== 'object') || scene.objects.some(o => !o || typeof o !== 'object')) return {
    errors: ['Elementos de plano no válidos.'],
    warnings
  };
  if (scene.floors.length < 1 || scene.floors.length > 12 || scene.objects.length > 500) return {
    errors: ['Máximo 12 pisos y 500 objetos por plano.'],
    warnings
  };
  if (scene.lighting && (!/^#[a-fA-F0-9]{6}$/.test(scene.lighting.background || '') || ![scene.lighting.ambient, scene.lighting.intensity].every(n => Number.isFinite(n) && n >= 0 && n <= 10))) errors.push('Iluminación no válida.');
  if (scene.views && (!Array.isArray(scene.views) || scene.views.length > 12 || scene.views.some(v => !v || typeof v.name !== 'string' || v.name.length > 100 || !Array.isArray(v.position) || !Array.isArray(v.target) || v.position.length !== 3 || v.target.length !== 3 || ![...v.position, ...v.target].every(n => Number.isFinite(n) && Math.abs(n) <= 2000) || !['perspectiva', 'superior', 'frontal', 'interior'].includes(v.view)||(v.fitToScene!==undefined&&typeof v.fitToScene!=='boolean')||(v.floorId!==undefined&&v.floorId!=='all'&&!scene.floors.some(f=>f.id===v.floorId))))) errors.push('Vistas de cámara no válidas.');
  const floors = new Map(),
    ids = new Set(),
    names = new Set();
  for (const f of scene.floors) {
    if (!idValido(f.id) || floors.has(f.id) || typeof f.name !== 'string' || !f.name.trim() || f.name.length > 100 || ![f.elevation, f.width, f.depth].every(Number.isFinite) || f.width < 2 || f.width > 500 || f.depth < 2 || f.depth > 500 || Math.abs(f.elevation) > 100) errors.push('Piso inválido o repetido.');
    if(f.surface!==undefined&&!['plane','platforms'].includes(f.surface))errors.push('Superficie de piso no válida.');
    if (f.background && (typeof f.background !== 'string' || f.background.length > 200000 || !/^data:image\/(png|jpeg|webp);base64,[A-Za-z0-9+/=]+$/.test(f.background))) errors.push('Fondo no compatible; utiliza PNG, JPEG o WebP de menos de 150 KB.');
    floors.set(f.id, f);
  }
  for (const o of scene.objects) {
    const key = String(o.id).toUpperCase().replace(/[\s-]/g, '');
    if (!idValido(o.id) || ids.has(key)) errors.push('Identificador de objeto inválido o duplicado.');
    ids.add(key);
    if (!TIPOS_OBJETO.includes(o.kind) || !floors.has(o.floorId) || typeof o.name !== 'string' || !o.name.trim() || o.name.length > 100 || !CAPAS.includes(o.layer) || !/^#[a-fA-F0-9]{6}$/.test(o.color || '')) errors.push('Objeto, nombre, capa o color no válido.');
    if (![o.x, o.z, o.y, o.w, o.d, o.h, o.rotation].every(Number.isFinite) || Math.abs(o.x) > 500 || Math.abs(o.z) > 500 || o.y < 0 || o.y > 100 || [o.w, o.d, o.h].some(n => n < 0.05 || n > 500) || Math.abs(o.rotation) > 360) errors.push('Medidas o posición fuera de rango.');
    if(o.detail!==undefined&&!DETALLES_ARQUITECTONICOS.includes(o.detail))errors.push('Detalle arquitectónico no válido.');
    if (o.material && !['mate', 'metal', 'madera', 'tela', 'vidrio'].includes(o.material)) errors.push('Material no válido.');
    if (typeof o.locked !== 'boolean' || typeof o.hidden !== 'boolean' || typeof o.reservable !== 'boolean') errors.push('Visibilidad o bloqueo no válido.');
    if (o.group && !idValido(o.group)) errors.push('Grupo no válido.');
    if (o.reservable) {
      if (!TIPOS_ZONA.includes(o.zoneType) || !Number.isInteger(o.capacity) || o.capacity < 1 || o.capacity > 10000) errors.push('Indica tipo y capacidad de cada zona reservable.');
      const n = o.floorId + ':' + o.name.trim().toLowerCase();
      if (names.has(n)) errors.push('Hay zonas con el mismo nombre en un piso.');
      names.add(n);
      const f = floors.get(o.floorId),
        a = o.rotation * Math.PI / 180,
        dx = (Math.abs(Math.cos(a)) * o.w + Math.abs(Math.sin(a)) * o.d) / 2,
        dz = (Math.abs(Math.sin(a)) * o.w + Math.abs(Math.cos(a)) * o.d) / 2;
      if (f && (Math.abs(o.x) + dx > f.width / 2 || Math.abs(o.z) + dz > f.depth / 2)) warnings.push(o.name + ': fuera del contorno del piso.');
      if (o.hidden) warnings.push(o.name + ': zona reservable oculta en el diseño.');
    }
  }
  if (!Array.isArray(scene.templates) || scene.templates.length > 12) errors.push('Biblioteca no válida: máximo 12 plantillas.');else for (const t of scene.templates) {
    if (!t || typeof t !== 'object') {
      errors.push('Plantilla no válida.');
      continue;
    }
    if (typeof t.name !== 'string' || !t.name.trim() || t.name.length > 100 || !Array.isArray(t.objects) || t.objects.length > 100) errors.push('Plantilla no válida: máximo 100 objetos.');else if (validarEscena({
      ...scene,
      objects: t.objects,
      templates: []
    }).errors.length) errors.push('La biblioteca contiene objetos no válidos.');
  }
  const rs = scene.objects.filter(o => o.reservable);
  if (publicar && !rs.length) errors.push('Añade al menos una zona reservable para publicar.');
  for (let i = 0; i < rs.length; i++) for (let j = i + 1; j < rs.length; j++) if (rs[i].floorId === rs[j].floorId && seSuperponen(rs[i], rs[j])) warnings.push(rs[i].name + ' y ' + rs[j].name + ': zonas superpuestas.');
  return {
    errors: [...new Set(errors)],
    warnings: [...new Set(warnings)]
  };
}
export function seSuperponen(a, b) {
  const vertices = o => {
    const r = o.rotation * Math.PI / 180;
    return [[-1, -1], [1, -1], [1, 1], [-1, 1]].map(([x, z]) => [o.x + x * o.w / 2 * Math.cos(r) - z * o.d / 2 * Math.sin(r), o.z + x * o.w / 2 * Math.sin(r) + z * o.d / 2 * Math.cos(r)]);
  };
  const A = vertices(a),
    B = vertices(b);
  return [a.rotation, b.rotation].every(r => [r, r + 90].every(d => {
    const x = Math.cos(d * Math.PI / 180),
      z = Math.sin(d * Math.PI / 180),
      p = A.map(v => v[0] * x + v[1] * z),
      q = B.map(v => v[0] * x + v[1] * z);
    return Math.max(...p) > Math.min(...q) + .01 && Math.max(...q) > Math.min(...p) + .01;
  }));
}
export function nuevoObjeto(kind, id, floorId, index = 1) {
  const reserved = ['mesa', 'silla', 'lounge', 'palco', 'sector'].includes(kind);
  const sizes = {
    mesa: [1.2, 1.2, .8],
    silla: [.5, .5, .9],
    lounge: [3, 2, .9],
    palco: [3, 2, .4],
    sector: [5, 5, .08],
    pared: [5, .15, 2.8],
    puerta: [1, .15, 2.2],
    ventana: [1.5, .12, 1.2],
    columna: [.5, .5, 3],
    escalera: [2, 4, 3],
    barra: [4, 1.1, 1.2],
    escenario: [8, 4, 1],
    plataforma: [4, 4, .4],
    banos: [3, 3, 2.8],
    entrada: [2, .2, 2.5],
    texto: [2, .2, .1]
  };
  const [w, d, h] = sizes[kind] || sizes.mesa;
  return {
    id,
    kind,
    floorId,
    name: kind.toUpperCase() + ' ' + index,
    x: 0,
    z: 0,
    y: 0,
    w,
    d,
    h,
    rotation: 0,
    color: reserved ? '#00c78b' : '#64748b',
    capacity: kind === 'silla' ? 1 : kind === 'mesa' ? 4 : 8,
    zoneType: {
      silla: 'ASIENTO',
      mesa: 'MESA',
      lounge: 'LOUNGE',
      palco: 'PALCO',
      sector: 'SECTOR'
    }[kind] || 'MESA',
    reservable: reserved,
    layer: reserved ? 'Zonas' : ['pared', 'puerta', 'ventana', 'columna', 'escalera'].includes(kind) ? 'Estructura' : 'Referencias',
    locked: false,
    hidden: false,
    group: ''
  };
}
export function escenaPalmarama() {
  return {
    schemaVersion: 1,
    units: 'm',
    floors: [{
      id: '1P',
      name: 'Planta baja',
      elevation: 0,
      width: 36,
      depth: 56
    }, {
      id: '2P',
      name: 'Segundo piso',
      elevation: 4,
      width: 36,
      depth: 56
    }],
    templates: [],
    objects: zonas.map(z => {
      const name = z.label.toUpperCase(),
        kind = name.includes('MESA') ? 'mesa' : name.includes('PALCO') ? 'palco' : 'lounge';
      return {
        ...nuevoObjeto(kind, z.id, name.startsWith('2P-') ? '2P' : '1P'),
        name: name.replace(/^2P-/, '').replace(/(MESA|LOUNGE|PALCO)(\d)/, '$1 $2'),
        x: (z.x + z.width / 2) * .05 - 18,
        z: (z.y + z.height / 2) * .05 - 28,
        w: z.width * .05,
        d: z.height * .05
      };
    })
  };
}
export const zonasDeEscena = scene => scene.objects.filter(o => o.reservable).map(o => ({
  id: o.id,
  label: o.name,
  tipoZona: o.zoneType,
  piso: scene.floors.find(f => f.id === o.floorId)?.name || o.floorId,
  floorId: o.floorId,
  x: (o.x + 250) * 20,
  y: (o.z + 250) * 20,
  width: o.w * 20,
  height: o.d * 20,
  estado: 'disponible',
  objeto3d: o
}));
